import React from "react";
import { Route, Switch } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import ScrollToTopOnMount from "../utils/ScrollToTopOnMount";

import OrdersSection from "../AdminSubapp/OrdersPanel/OrdersSection";
import MenusSection from "./MenusSection/MenusSection";
import Component404 from "../utils/ui_components/404Component";

import "./employeeApp.css";

import Navbar from "./Navbar/Navbar";
import Hint from "../utils/Hint/Hint";

const EmployeeApp = ({
  handleLogout,
  activeOrders,
  setActiveOrders,
  isActiveOrdersLoading,
  handleUpdateOrderAdmin,
  handleUpdateOrderChef,
  handleConfirmOrder,
  handleInactivateOrder,
  allMenus,
  handleUpdateMenu,
  dishes
}) => {
  return (
    <>
      <Navbar
        activeUncheckedOrders={
          activeOrders &&
          activeOrders.filter((order) => order.orderStatus === "requested")
        }
        handleLogout={handleLogout}
      />
      <div style={{ width: "100%", height: "2em" }}>
        <Hint
          hintHeading="Employee sub application"
          hintText={`
        <div>
        This sub-application demonstrates one of the options of how parts of the system's functionality can be divided among the company's workers, providing a robust and straightforward workflow. 
        </div>
        <div>
        In this example, the sub-application provides full order-handling and partial menu-handling functionality.
        </div>
        <div>
        Since the application is fully responsive, it can be used from any device: desktop, mobile, or tablet. All that is required are the Internet connection and login credentials.
        </div>
        <div>
        Depending on the business' requirements, administration application can be separated further, providing a more precise distribution of responsibilities. A medium-sized business with a relatively large number of employees might benefit from logging actions made to the database and their authors. The role-based approach of the system excels in this task.
        </div>
        `}
          openOnMount={false}
          top="0"
        />
        <h2
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            fontFamily: "Arial"
          }}
        >
          Employee sub-application
        </h2>
      </div>
      <div className="segment chefApp__segment">
        <Route
          render={({ location, match }) => {
            const { pathname, key } = location;

            return (
              <TransitionGroup component={null}>
                <CSSTransition
                  in={pathname != null}
                  key={location.key}
                  timeout={300}
                  classNames="section"
                  unmountOnExit
                >
                  <ScrollToTopOnMount>
                    <Switch location={location}>
                      <Route path="/menus">
                        <MenusSection
                          allMenus={allMenus}
                          handleUpdateMenu={handleUpdateMenu}
                          dishes={dishes}
                        />
                      </Route>
                      <Route exact path="/">
                        <OrdersSection
                          activeOrders={
                            activeOrders &&
                            activeOrders
                              .filter((o) => o.active)
                              .filter(
                                (order) => order.orderType === "dailymenuOrder"
                              )
                          }
                          setActiveOrders={setActiveOrders}
                          isActiveOrdersLoading={isActiveOrdersLoading}
                          handleUpdateOrderAdmin={handleUpdateOrderAdmin}
                          handleUpdateOrderChef={handleUpdateOrderChef}
                          handleConfirmOrder={handleConfirmOrder}
                          handleInactivateOrder={handleInactivateOrder}
                        />
                      </Route>
                      <Route path="*" component={Component404} />
                    </Switch>
                  </ScrollToTopOnMount>
                </CSSTransition>
              </TransitionGroup>
            );
          }}
        />
      </div>
      <div className="chefApp__segment__footer">
        <div>Dmitry Zhukov 2020 ©</div>
        <div>Want to augment your business with a custom solution?</div>
        <div>
          Contact me at{" "}
          <a
            style={{ color: "inherit" }}
            target="blank"
            href="https://zdcreatech.com/"
          >
            my website
          </a>
        </div>
        <div style={{ fontSize: "x-small" }}>
          Stock photos from:{" "}
          <a
            target="blank"
            style={{ textDecoration: "none", color: "white" }}
            href="https://www.pexels.com/"
          >
            pexels.com
          </a>
          ,{" "}
          <a
            style={{ textDecoration: "none", color: "white" }}
            href="https://www.foodiesfeed.com/"
            target="blank"
          >
            foodiesfeed.com
          </a>
          .
        </div>
        <div style={{ fontSize: "x-small" }}>
          This website uses cookies to increase user experience.
        </div>
      </div>
    </>
  );
};

export default EmployeeApp;
